<template>
  <v-row dense>
    <v-col cols="6" sm="5" md="3" lg="3">
      <v-text-field
        v-model="search"
        prepend-icon="mdi-magnify"
        label="Search anything here ..."
        single-line
        solo
        hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="6" sm="5" md="3" lg="3">
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="selectedDates"
        width="290px"
        class=""
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedDatesText"
            prepend-icon="mdi-calendar"
            append-icon="mdi-chevron-down"
            readonly
            v-bind="attrs"
            v-on="on"
            solo
            class="custom-select"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="selectedDates"
          class="custom-date-picker"
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            class="error-text-lighten-1"
            text
            @click.prevent="cancelSelection"
          >
            Cancel
          </v-btn>
          <v-btn text @click.prevent="confirmSelection"> OK </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col cols="6" sm="4" md="2" lg="2">
      <v-select
        solo
        :items="formatedAccountTypes"
        @change="handleAccount"
        item-value="id"
        item-text="account_type_display"
        append-icon="mdi-chevron-down"
        label="Account types"
        class="custom-select"
      ></v-select>
    </v-col>
    <v-col cols="6" sm="5" md="3" lg="2">
      <v-select
        solo
        :items="generateLevelsArray"
        v-model="selectedLevel"
        append-icon="mdi-chevron-down"
        label="All Level"
        class="custom-select"
        @change="levelFilter"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="3" md="2" lg="2">
      <ul>
        <li>
          <span>Total Commission:</span>
          <span>{{ Number(totalCommission)?.toFixed(2) }}</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="12" sm="12">
      <v-card
        class="pa-0 rounded-0 elevation-0"
        :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
      >
        <v-sheet
          class="transactionTable ib-commission-table"
          :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'"
        >
          <v-data-table
            :search="search"
            :items-per-page="10"
            :headers="headers"
            :items="ibCommissionStatistics"
            loading-text="Loading... Please wait"
            :loading="isLoading"
          >
            <template v-slot:item.volume="{ item }">
              {{ item?.volume }}
            </template>
            <template v-slot:item.updated_at="{ item }">
              {{ item?.updated_at}}
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  PARTNERCOMMISSION__ACTIONS,
  TRADINGACCTYPES__ACTIONS,
  ALLACCOUNTSSUMMARY__ACTIONS,
} from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Sl", value: "sl" },
        // { text: "Update Time", value: "updated_at" },
        { text: "Client", value: "name" },
        { text: "Acc No", value: "account_no" },
        { text: "Position", value: "position_id" },
        { text: "Close Time", value: "to_date" },
        { text: "Lot", value: "volume" },
        { text: "Symbol", value: "symbol" },
        { text: "Acc Type", value: "account_type" },
        { text: "Level", value: "level" },
        { text: "Commission ($)", value: "commission" },
      ],
      search: "",
      selectedDates: [],
      selectedDatesText: null,
      selectedLevel: null,
      selectedAccount: null,
      modal: false,
    };
  },
  computed: {
    ...mapState("commissionstatistics", [
      "ibCommissionStatistics",
      "totalCommission",
      "isLoading",
    ]),

    ...mapState("accounttypes", ["accounttypes"]),
    ...mapState("accountsummary", ["accountsummary"]),

    formatedAccountTypes() {
      const accountNumbers = this.accounttypes.map((item) => {
        const { id, account_type_display } = item;
        return { id, account_type_display };
      });
      return ["All", ...accountNumbers];
    },
    generateLevelsArray() {
      const levelsArray = [];
      if (this.accountsummary && this.accountsummary.businessLevel) {
        for (let i = 0; i < this.accountsummary.businessLevel; i++) {
          levelsArray.push(`Level ${i + 1}`);
        }
      }
      return ["All Level", ...levelsArray];
    },
  },
  methods: {
    ...mapActions("commissionstatistics", [
      PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS,
    ]),

    ...mapActions("accountsummary", [
      ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY,
    ]),

    ...mapActions("accounttypes", [TRADINGACCTYPES__ACTIONS.TRADINGACCTYPES]),

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    handleAccount(selectedAccount) {
      this.selectedAccount = selectedAccount;

      let parameter = {};

      // Check if selectedDates has valid values
      if (
        Array.isArray(this.selectedDates) &&
        this.selectedDates.length === 2
      ) {
        let startDate = new Date(this.selectedDates[0]);
        let endDate = new Date(this.selectedDates[1]);

        // Swap dates if startDate is greater than endDate
        if (startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
        }

        // Format dates
        const startDateISO = startDate.toISOString().split("T")[0];
        const endDateISO = endDate.toISOString().split("T")[0];

        // Add duration to parameters
        parameter.duration = `${startDateISO}to${endDateISO}`;
      }

      // Add selectedLevel to parameters
      parameter.level =
        this.selectedLevel === "All Level"
          ? null
          : Number(this.selectedLevel?.replace(/\D/g, ""));

      // Add selectedAccount to parameters
      parameter.account_type = selectedAccount;

      this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS](parameter);
    },

    confirmSelection() {
      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        level:
          this.selectedLevel === "All Level"
            ? null
            : Number(this.selectedLevel?.replace(/\D/g, "")),
        account_type: this.selectedAccount,
        duration: `${startDate.toISOString().split("T")[0]}to${
          endDate.toISOString().split("T")[0]
        }`,
      };

      this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    levelFilter() {
      let parameter = {};

      // Check if selectedDates has valid values
      if (
        Array.isArray(this.selectedDates) &&
        this.selectedDates.length === 2
      ) {
        let startDate = new Date(this.selectedDates[0]);
        let endDate = new Date(this.selectedDates[1]);

        // Swap dates if startDate is greater than endDate
        if (startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
        }

        // Format dates
        const startDateISO = startDate.toISOString().split("T")[0];
        const endDateISO = endDate.toISOString().split("T")[0];

        // Add duration to parameters
        parameter.duration = `${startDateISO}to${endDateISO}`;
      }

      // Check if selectedAccount has a value
      if (this.selectedAccount) {
        // Add selectedAccount to parameters
        parameter.account_type = this.selectedAccount;
      }

      // Add level to parameters
      parameter.level =
        this.selectedLevel === "All Level"
          ? null
          : Number(this.selectedLevel?.replace(/\D/g, ""));

      this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS](parameter);
    },
  },
  async mounted() {
    await this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS]();
    await this[TRADINGACCTYPES__ACTIONS.TRADINGACCTYPES]();
    await this[ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
